module.exports = __webpack_public_path__ + "media/conversa/LogoIcoConversa-f385e3ea.png";